/* =========================================================================
   Cyanotype Negative Tool — bearly.art
   GA4 bridge (top) + Klaviyo email gate + client-side cyanotype engine.
   ========================================================================= */

/* ---------------- GA4 bridge ----------------
   The Shopify Google & YouTube app pixel is sandboxed and can't see page
   dataLayer events, so we load gtag ourselves on a separate queue and
   forward this tool's cy_* events directly. */
(function () {
  var MEASUREMENT_ID = "G-G0QSCXENNN";
  var QUEUE = "cyDataLayer";

  function consentOk() {
    try {
      if (window.Shopify && Shopify.customerPrivacy &&
          typeof Shopify.customerPrivacy.analyticsProcessingAllowed === "function") {
        return Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return true;
  }

  window[QUEUE] = window[QUEUE] || [];
  window.cyGtag = function () { window[QUEUE].push(arguments); };

  var s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + MEASUREMENT_ID + "&l=" + QUEUE;
  document.head.appendChild(s);

  var debug = /[?&]debug_mode=1/.test(location.search);
  cyGtag("js", new Date());
  var cfg = { send_page_view: false };
  if (debug) cfg.debug_mode = true;
  cyGtag("config", MEASUREMENT_ID, cfg);

  // Forward cy_* events pushed onto window.dataLayer.
  window.dataLayer = window.dataLayer || [];
  var origPush = window.dataLayer.push.bind(window.dataLayer);
  window.dataLayer.push = function (obj) {
    try {
      if (obj && typeof obj === "object" && typeof obj.event === "string" &&
          obj.event.indexOf("cy_") === 0 && consentOk()) {
        var params = {};
        for (var k in obj) if (k !== "event" && Object.prototype.hasOwnProperty.call(obj, k)) params[k] = obj[k];
        if (debug) params.debug_mode = true;
        cyGtag("event", obj.event, params);
      }
    } catch (e) {}
    return origPush(obj);
  };
})();

/* ---------------- Tracking + Klaviyo helpers ---------------- */
var cyTrack = function (name, params) {
  var o = params ? JSON.parse(JSON.stringify(params)) : {};
  o.event = name;
  (window.dataLayer = window.dataLayer || []).push(o);
};

var CY_KLAVIYO = {
  company: "SCGZFP",
  list: "Si3Bsy",
  revision: "2024-10-15",
  emailKey: "ba_tools_email",

  storedEmail: function () {
    try { return localStorage.getItem(this.emailKey) || ""; } catch (e) { return ""; }
  },
  storeEmail: function (email) {
    try { localStorage.setItem(this.emailKey, email); } catch (e) {}
  },
  subscribe: function (email) {
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + this.company, {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": this.revision },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Cyanotype Tool",
            profile: { data: { type: "profile", attributes: { email: email } } }
          },
          relationships: { list: { data: { type: "list", id: this.list } } }
        }
      })
    });
  },
  event: function (name, email, props) {
    if (!email) return;
    fetch("https://a.klaviyo.com/client/events/?company_id=" + this.company, {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": this.revision },
      body: JSON.stringify({
        data: {
          type: "event",
          attributes: {
            properties: props || {},
            metric: { data: { type: "metric", attributes: { name: name } } },
            profile: { data: { type: "profile", attributes: { email: email } } }
          }
        }
      })
    }).catch(function () {});
  }
};

/* ---------------- Cyanotype engine ---------------- */
(function () {
  "use strict";

  var root = document.getElementById("cyanotype-root");
  if (!root) return;

  // ---------- State ----------
  var state = {
    img: null,
    srcW: 0, srcH: 0,
    lum: null,
    pw: 0, ph: 0,
    noise: null,
    fiber: null,
    brushMask: null,
    tab: "print",
    settings: {
      contrast: 1, gamma: 1, bright: 0,
      mirror: false,
      exposure: 1, paper: 50,
      texture: true, brush: true
    }
  };

  var PREVIEW_MAX = 1100;

  // ---------- DOM ----------
  var $ = function (id) { return document.getElementById(id); };
  var canvas = $("cy-canvas");
  var ctx = canvas.getContext("2d");
  var wrap = $("cy-canvas-wrap");
  var dropMsg = $("cy-drop-msg");
  var exportBtn = $("cy-export-btn");
  var exportPrevBtn = $("cy-export-preview-btn");

  cyTrack("cy_tool_view", { page_location: location.href });

  // ---------- Cyanotype color ramp ----------
  var RAMP = [
    [0.00, 245, 240, 226],
    [0.12, 220, 228, 226],
    [0.30, 158, 190, 210],
    [0.52, 84, 130, 178],
    [0.74, 35, 78, 138],
    [0.90, 18, 48, 100],
    [1.00, 8, 27, 62]
  ];

  function rampColor(t, paperWarm) {
    t = t < 0 ? 0 : t > 1 ? 1 : t;
    var i = 1;
    while (i < RAMP.length - 1 && RAMP[i][0] < t) i++;
    var a = RAMP[i - 1], b = RAMP[i];
    var f = (t - a[0]) / ((b[0] - a[0]) || 1);
    var r = a[1] + (b[1] - a[1]) * f;
    var g = a[2] + (b[2] - a[2]) * f;
    var bl = a[3] + (b[3] - a[3]) * f;
    var lightness = 1 - t;
    var warmShift = (paperWarm - 0.5) * 18 * lightness * lightness;
    r += warmShift;
    bl -= warmShift * 0.9;
    return [r, g, bl];
  }

  // ---------- Tone pipeline (shared by preview + export) ----------
  function tone(l, s) {
    var a = l + s.bright / 255;
    a = (a - 0.5) * s.contrast + 0.5;
    a = a < 0 ? 0 : a > 1 ? 1 : a;
    return Math.pow(a, 1 / s.gamma);
  }

  function printDensity(adjusted, exposure) {
    var d = (1 - adjusted) * exposure;
    var fog = 0.035 * Math.max(0, exposure - 1);
    var D = 1 - Math.exp(-2.7 * (d + fog));
    return D / (1 - Math.exp(-2.7 * 2.2));
  }

  // ---------- HEIC + decode (iPhone-safe) ----------
  var heicLoader = null;
  function ensureHeic2any() {
    if (!heicLoader) {
      heicLoader = new Promise(function (res, rej) {
        var s = document.createElement("script");
        s.src = "https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js";
        s.onload = res;
        s.onerror = function () { heicLoader = null; rej(new Error("heic2any failed to load")); };
        document.head.appendChild(s);
      });
    }
    return heicLoader;
  }

  function heicToJpeg(file) {
    return ensureHeic2any().then(function () {
      return heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 });
    }).then(function (out) { return Array.isArray(out) ? out[0] : out; });
  }

  function decodeImage(blob) {
    if ("createImageBitmap" in window) {
      return createImageBitmap(blob, { imageOrientation: "from-image" }).catch(function () {
        return decodeViaImg(blob);
      });
    }
    return decodeViaImg(blob);
  }
  function decodeViaImg(blob) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); res(img); };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error("decode failed")); };
      img.src = url;
    });
  }

  // ---------- Loading ----------
  $("cy-load-btn").addEventListener("click", function () { $("cy-file-input").click(); });
  $("cy-file-input").addEventListener("change", function (e) {
    if (e.target.files && e.target.files[0]) loadFile(e.target.files[0]);
  });
  ["dragover", "dragenter"].forEach(function (ev) {
    wrap.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.add("cy-dragover"); });
  });
  ["dragleave", "drop"].forEach(function (ev) {
    wrap.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.remove("cy-dragover"); });
  });
  wrap.addEventListener("drop", function (e) {
    var f = e.dataTransfer.files && e.dataTransfer.files[0];
    if (f) loadFile(f);
  });

  function loadFile(file) {
    $("cy-img-info").textContent = "Loading\u2026";
    var isHeic = /\.hei[cf]$/i.test(file.name) || /hei[cf]/i.test(file.type || "");
    var blobPromise = isHeic ? heicToJpeg(file) : Promise.resolve(file);

    blobPromise
      .then(function (blob) {
        return decodeImage(blob).catch(function (err) {
          if (!isHeic) return heicToJpeg(file).then(decodeImage); // undetected HEIC retry
          throw err;
        });
      })
      .then(function (img) {
        state.img = img;
        state.srcW = img.naturalWidth || img.width;
        state.srcH = img.naturalHeight || img.height;
        buildPreviewData();
        $("cy-img-info").textContent = file.name + " \u2014 " + state.srcW + "\u00d7" + state.srcH + "px";
        exportBtn.disabled = false;
        exportPrevBtn.disabled = false;
        dropMsg.classList.add("cy-hidden");
        canvas.classList.remove("cy-hidden");
        render();
        cyTrack("cy_file_upload", { file_type: file.type || "unknown", px_w: state.srcW, px_h: state.srcH });
        CY_KLAVIYO.event("Started Cyanotype", CY_KLAVIYO.storedEmail(), {});
      })
      .catch(function () {
        $("cy-img-info").textContent =
          "Couldn't read that photo. Try a JPEG or PNG, or re-share it from the Photos app (which converts it automatically).";
        cyTrack("cy_upload_error", { message: "decode failed", file_type: file.type || "unknown" });
      });
  }

  function buildPreviewData() {
    var scale = Math.min(1, PREVIEW_MAX / Math.max(state.srcW, state.srcH));
    var pw = Math.max(1, Math.round(state.srcW * scale));
    var ph = Math.max(1, Math.round(state.srcH * scale));
    state.pw = pw; state.ph = ph;

    var off = document.createElement("canvas");
    off.width = pw; off.height = ph;
    var octx = off.getContext("2d", { willReadFrequently: true });
    octx.drawImage(state.img, 0, 0, pw, ph);
    var data = octx.getImageData(0, 0, pw, ph).data;

    var n = pw * ph;
    var lum = new Float32Array(n);
    for (var i = 0; i < n; i++) {
      var j = i * 4;
      lum[i] = (0.2126 * data[j] + 0.7152 * data[j + 1] + 0.0722 * data[j + 2]) / 255;
    }
    state.lum = lum;

    var noise = new Float32Array(n);
    for (var k = 0; k < n; k++) noise[k] = Math.random() - 0.5;
    state.noise = noise;

    state.fiber = makeValueNoise(pw, ph, 90);
    state.brushMask = makeBrushMask(pw, ph);

    canvas.width = pw;
    canvas.height = ph;
  }

  function makeValueNoise(w, h, cell) {
    var gw = Math.ceil(w / cell) + 2, gh = Math.ceil(h / cell) + 2;
    var grid = new Float32Array(gw * gh);
    for (var i = 0; i < grid.length; i++) grid[i] = Math.random();
    var out = new Float32Array(w * h);
    var smooth = function (t) { return t * t * (3 - 2 * t); };
    for (var y = 0; y < h; y++) {
      var gy = y / cell, y0 = Math.floor(gy), fy = smooth(gy - y0);
      for (var x = 0; x < w; x++) {
        var gx = x / cell, x0 = Math.floor(gx), fx = smooth(gx - x0);
        var i00 = grid[y0 * gw + x0], i10 = grid[y0 * gw + x0 + 1];
        var i01 = grid[(y0 + 1) * gw + x0], i11 = grid[(y0 + 1) * gw + x0 + 1];
        var top = i00 + (i10 - i00) * fx;
        var bot = i01 + (i11 - i01) * fx;
        out[y * w + x] = top + (bot - top) * fy - 0.5;
      }
    }
    return out;
  }

  function makeBrushMask(w, h) {
    var mask = new Float32Array(w * h);
    var m = Math.round(Math.min(w, h) * 0.035);
    var eL = makeEdge(h, m), eR = makeEdge(h, m);
    var eT = makeEdge(w, m), eB = makeEdge(w, m);
    for (var y = 0; y < h; y++) {
      var left = m + eL[y];
      var right = w - m - eR[y];
      for (var x = 0; x < w; x++) {
        var top = m + eT[x];
        var bottom = h - m - eB[x];
        var v = 1;
        var feather = m * 0.7 + 1;
        v = Math.min(v, (x - left) / feather);
        v = Math.min(v, (right - x) / feather);
        v = Math.min(v, (y - top) / feather);
        v = Math.min(v, (bottom - y) / feather);
        mask[y * w + x] = v < 0 ? 0 : v > 1 ? 1 : v;
      }
    }
    return mask;

    function makeEdge(len, mm) {
      var arr = new Float32Array(len);
      var p1 = Math.random() * 6.28, p2 = Math.random() * 6.28;
      var f1 = 0.5 + Math.random(), f2 = 3 + Math.random() * 3;
      var jitter = 0;
      for (var i = 0; i < len; i++) {
        jitter += (Math.random() - 0.5) * mm * 0.25;
        jitter *= 0.9;
        arr[i] =
          Math.sin((i / len) * 6.28 * f1 + p1) * mm * 0.5 +
          Math.sin((i / len) * 6.28 * f2 + p2) * mm * 0.3 +
          jitter;
      }
      return arr;
    }
  }

  // ---------- Rendering ----------
  var raf = 0;
  function render() {
    if (!state.lum) return;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      if (state.tab === "print") renderPrint();
      else renderNegative();
    });
  }

  function renderPrint() {
    var s = state.settings;
    var pw = state.pw, ph = state.ph, lum = state.lum,
        noise = state.noise, fiber = state.fiber, brushMask = state.brushMask;
    var img = ctx.createImageData(pw, ph);
    var d = img.data;
    var warm = s.paper / 100;
    var paperBase = rampColor(0, warm);

    for (var i = 0; i < lum.length; i++) {
      var adjusted = tone(lum[i], s);
      var D = printDensity(adjusted, s.exposure);

      if (s.texture) {
        var g = noise[i] * 0.045 * (1 - Math.abs(D * 2 - 1));
        var f = fiber[i] * 0.05;
        D += g + f * (0.35 + D * 0.5);
        D = D < 0 ? 0 : D > 1 ? 1 : D;
      }

      var r, g2, b;
      var cov = s.brush ? brushMask[i] : 1;
      if (cov <= 0) {
        r = paperBase[0]; g2 = paperBase[1]; b = paperBase[2];
        if (s.texture) {
          var ff = fiber[i] * 10;
          r += ff; g2 += ff; b += ff;
        }
      } else {
        var c = rampColor(D * cov, warm);
        r = c[0]; g2 = c[1]; b = c[2];
        if (s.texture) {
          var f2 = fiber[i] * 6 * (1 - D);
          r += f2; g2 += f2; b += f2;
        }
      }

      var j = i * 4;
      d[j] = r; d[j + 1] = g2; d[j + 2] = b; d[j + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
  }

  function renderNegative() {
    var s = state.settings;
    var pw = state.pw, ph = state.ph, lum = state.lum;
    var img = ctx.createImageData(pw, ph);
    var d = img.data;
    for (var y = 0; y < ph; y++) {
      for (var x = 0; x < pw; x++) {
        var sx = s.mirror ? pw - 1 - x : x;
        var adjusted = tone(lum[y * pw + sx], s);
        var v = Math.round((1 - adjusted) * 255);
        var j = (y * pw + x) * 4;
        d[j] = v; d[j + 1] = v; d[j + 2] = v; d[j + 3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
  }

  // ---------- Email gate ----------
  var modalBg = $("cy-modal-bg");
  var emailInput = $("cy-email-input");
  var emailErr = $("cy-email-err");
  var pendingDownload = null;

  function gate(fn) {
    if (CY_KLAVIYO.storedEmail()) { fn(); return; }
    pendingDownload = fn;
    emailErr.textContent = "";
    modalBg.classList.remove("cy-hidden");
    emailInput.focus();
  }

  function submitEmail() {
    var email = (emailInput.value || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailErr.textContent = "That doesn't look like an email address.";
      return;
    }
    emailErr.textContent = "";
    $("cy-email-submit").disabled = true;
    CY_KLAVIYO.subscribe(email)
      .catch(function () {}) // don't block the download on network hiccups
      .then(function () {
        CY_KLAVIYO.storeEmail(email);
        cyTrack("cy_email_submit", {});
        $("cy-email-submit").disabled = false;
        modalBg.classList.add("cy-hidden");
        if (pendingDownload) { var fn = pendingDownload; pendingDownload = null; fn(); }
      });
  }
  $("cy-email-submit").addEventListener("click", submitEmail);
  emailInput.addEventListener("keydown", function (e) { if (e.key === "Enter") submitEmail(); });

  // ---------- Export ----------
  exportBtn.addEventListener("click", function () {
    if (!state.img) return;
    gate(function () {
      doExportNegative();
      cyTrack("cy_download_click", { kind: "negative" });
      CY_KLAVIYO.event("Used Cyanotype", CY_KLAVIYO.storedEmail(), { kind: "negative" });
    });
  });

  exportPrevBtn.addEventListener("click", function () {
    if (!state.lum) return;
    gate(function () {
      doExportPreview();
      cyTrack("cy_download_click", { kind: "preview" });
      CY_KLAVIYO.event("Used Cyanotype", CY_KLAVIYO.storedEmail(), { kind: "preview" });
    });
  });

  function doExportNegative() {
    var s = state.settings;
    var w = state.srcW, h = state.srcH;
    var off = document.createElement("canvas");
    off.width = w; off.height = h;
    var octx = off.getContext("2d", { willReadFrequently: true });
    octx.drawImage(state.img, 0, 0, w, h);
    var img = octx.getImageData(0, 0, w, h);
    var d = img.data;

    var vals = new Uint8ClampedArray(w * h);
    for (var i = 0; i < w * h; i++) {
      var j = i * 4;
      var l = (0.2126 * d[j] + 0.7152 * d[j + 1] + 0.0722 * d[j + 2]) / 255;
      vals[i] = Math.round((1 - tone(l, s)) * 255);
    }
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var sx = s.mirror ? w - 1 - x : x;
        var v = vals[y * w + sx];
        var jj = (y * w + x) * 4;
        d[jj] = v; d[jj + 1] = v; d[jj + 2] = v; d[jj + 3] = 255;
      }
    }
    octx.putImageData(img, 0, 0);
    download(off, "cyanotype-negative.png");
  }

  function doExportPreview() {
    var wasTab = state.tab;
    state.tab = "print";
    renderPrint();
    download(canvas, "cyanotype-preview.png");
    state.tab = wasTab;
    render();
  }

  function download(cnv, name) {
    cnv.toBlob(function (blob) {
      if (!blob) {
        $("cy-img-info").textContent = "Export failed — the image may be too large for this device. Try a smaller photo.";
        return;
      }
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.rel = "noopener";
      if ("download" in a) {
        a.download = name;
        document.body.appendChild(a); // required for iOS Safari/Chrome
        a.click();
        a.remove();
      } else {
        window.open(url, "_blank");
      }
      setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
    }, "image/png");
  }

  // ---------- Wiring ----------
  function bindSlider(id, key, outId, fmt) {
    var el = $(id), out = $(outId);
    el.addEventListener("input", function () {
      state.settings[key] = parseFloat(el.value);
      out.textContent = fmt(el.value);
      render();
    });
  }
  bindSlider("cy-s-contrast", "contrast", "cy-v-contrast", function (v) { return (+v).toFixed(2); });
  bindSlider("cy-s-gamma", "gamma", "cy-v-gamma", function (v) { return (+v).toFixed(2); });
  bindSlider("cy-s-bright", "bright", "cy-v-bright", function (v) { return v; });
  bindSlider("cy-s-exposure", "exposure", "cy-v-exposure", function (v) { return (+v).toFixed(2); });
  bindSlider("cy-s-paper", "paper", "cy-v-paper", function (v) { return v; });

  function bindToggle(id, key) {
    var el = $(id);
    el.addEventListener("change", function () {
      state.settings[key] = el.checked;
      render();
    });
  }
  bindToggle("cy-t-mirror", "mirror");
  bindToggle("cy-t-texture", "texture");
  bindToggle("cy-t-brush", "brush");

  var tabPrint = $("cy-tab-print"), tabNeg = $("cy-tab-neg");
  function setTab(name) {
    state.tab = name;
    tabPrint.setAttribute("aria-selected", name === "print");
    tabNeg.setAttribute("aria-selected", name === "neg");
    render();
  }
  tabPrint.addEventListener("click", function () { setTab("print"); });
  tabNeg.addEventListener("click", function () { setTab("neg"); });
})();